<ng-container *ngIf="similarProperties && similarProperties.items?.length && similarProperties.items!.length > 0">
    <div class="relative w-full" *transloco="let t; prefix('shared.similar-properties')">
        <h3 class="h2 text-black my-4">{{t('similarPropertiesHeader')}}</h3>
        <div class="grid grid-cols-2 gap-4">
            <app-property-card-item *ngFor="let property of similarProperties.items"
                [propertySummary]="property" [newWindow]="newWindow">
            </app-property-card-item>
        </div>
    </div>
</ng-container>
